export default "__VITE_ASSET__DLeVptcB__"